import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NavbarService } from '../../_services/navbar.service';
import { Router } from '@angular/router';
import { INavMenu } from '../../navbar/navbar.component';
import { SuccessDialogService } from '../../_services/success-dialog.service';
import { SessionActivityDataForm } from '../../_models/session-activity-data-form';
import { MatStepper } from '@angular/material';
import { SesssionActivityService } from '../../_services/sesssion-activity.service';
import { UserSessionDataForm } from '../../_models/login/user-session-data-form';
import { TestResultsService } from '../../_services/test-results.service';

@Component({
  selector: 'app-learning-search',
  templateUrl: './learning-search.component.html',
  styleUrls: ['./learning-search.component.css']
})
export class LearningSearchComponent implements OnInit {

 //  @Input('matTooltip') message: string;
  @ViewChild('stepper') stepper: MatStepper;

  message: string;
  displayedColumns: string[] = ['beginner', 'professional'];
  displayedColumns1: string[] = ['Operator', 'usage', 'function', 'example'];
  displayedColumns2: string[] = ['Operators', 'google', 'uspto', 'espacenet', 'wipo'];
  dataSource = ELEMENT_DATA;
  dataSource1 = ELEMENT_DATA1;
  dataSource2 = ELEMENT_DATA2;
  learningTitle: string = '';
  navItemSelected: string = '';

  navMenu: INavMenu[] = [];
  userDataSession;
  userDetailsId = 0;
  stepperIndex: number;
  lastSessionActivityNumber: number;
  sessionActivityDataForm: SessionActivityDataForm = new SessionActivityDataForm();

  sessionActivity;
  userTestResults;

  constructor(private navbarService: NavbarService,
    private router: Router,
    private successDialogService: SuccessDialogService,
    private sesssionActivityService: SesssionActivityService,
    private testResultsService : TestResultsService
  ) {

  }

  ngOnInit() {
    this.navMenu = this.navbarService.getNavMenu();
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);
    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userDetailsId = this.userDataSession.userDetailsId;
    }
    this.getLastSessionAcgtivityBYUserId(this.userDetailsId, 3);
    this.getUserTestResults(this.userDetailsId, 2)
  }

  getUserTestResults(userId,testType){
    this.testResultsService.getUserTestResults(userId, testType).subscribe(
      resp => {
        this.userTestResults = resp;
      }, error => {
        console.log(error);
      })
  }

  getLastSessionAcgtivityBYUserId(userDetailId, activityType) {
    this.sesssionActivityService.getLastSessionActiityByUserId(userDetailId, activityType).subscribe(
      resp => {
        this.sessionActivity = resp;
        if(this.sessionActivity == null){
        }else{
        this.lastSessionActivityNumber = this.sessionActivity.lastActivitySession - 1;
        this.stepper._stepHeader.forEach(
          step => {
            if (step.index <= this.lastSessionActivityNumber) {
              setTimeout(() => {
                this.stepper.selectedIndex = step.index;
              });
            }
          })
        }
      }, error => {
        console.log(error);
      })
  }

  isSeenFirst = false;
  isSeenSecond = false;
  isSeenThird = false;
  isSeenFour = false;
  isSeenFive = false;
  isSeenSix = false;
  isSeenSeven = false;
  isSeenEight = false;

  moveNextIndex() {

    let indexNumber = this.stepper.selectedIndex + 1;
    this.sessionActivityDataForm.activityType = 3
    const currentUser = localStorage.getItem('currentUser');
    this.sessionActivityDataForm.userDetails = JSON.parse(currentUser);
    switch (indexNumber) {
      case (2):
        if (!this.isSeenSecond) {
          this.isSeenSecond = true;
          this.sessionActivityDataForm.lastActivitySession = 2;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (3):
        if (!this.isSeenThird) {
          this.isSeenThird = true;
          this.sessionActivityDataForm.lastActivitySession = 3;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (4):
        if (!this.isSeenFour) {
          this.isSeenFour = true;
          this.sessionActivityDataForm.lastActivitySession = 4;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (5):
        if (!this.isSeenFive) {
          this.isSeenFive = true;
          this.sessionActivityDataForm.lastActivitySession = 5;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (6):
        if (!this.isSeenSix) {
          this.isSeenSix = true;
          this.sessionActivityDataForm.lastActivitySession = 6;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (7):
        if (!this.isSeenSeven) {
          this.isSeenSeven = true;
          this.sessionActivityDataForm.lastActivitySession = 7;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      case (8):
        if (!this.isSeenEight) {
          this.isSeenEight = true;
          this.sessionActivityDataForm.lastActivitySession = 8;
          this.sesssionActivityService.saveUesrSessionActiity(this.sessionActivityDataForm).subscribe(
            resp => {
              this.sessionActivityDataForm = resp as SessionActivityDataForm;
            }, error => {
              console.log(error);
            })
        }
        break;
      default:
        break;
    }
  }


  getStepperIndexVaule(value) {
    switch (value) {
      case 1:
        this.message = " Patent Search and its benefits";
        break;
      case 2:
        this.message = "Approach for identifying existence of similar invention";
        break;
      case 3:
        this.message = "Importance of a Professional Help";
        break;
      case 4:
        this.message = "Easy Search - Approach for identifying existence of similar invention";
        break;
      case 5:
        this.message = "Advanced Search - Approach for identifying existence of similar invention ";
        break;
      case 6:
        this.message = "Advanced Search - Expert Tips";
        break;
      case 7:
        this.message = "Advanced Search - Classification";
        break;
      case 8:
        this.message = "Advanced Search - Operators comparison list in various patent sources";
        break;
      default:
        break;
    }
  }
  // moveToBasicQuizz(itemValue: string): void  {
  //   this.navItemSelected = itemValue;
  //   this.navbarService.saveActiveNavItem(this.navItemSelected);
  // }

  // ===== Success Dialog =====
  moveToPatentSearchQuizz(){
    if(this.userTestResults == null){
      this.navbarService.saveActiveNavItem('Patent Search Quiz')
      this.successDialogService.successDialog(3);
    }else{
      this.navbarService.saveActiveNavItem('Patent Drafting')
      this.router.navigate(['/main/learning/learnPatentDraft']);
    }
  }

}

export interface slide3 {
  beginner: string;
  professional: string;
}

export interface slide5 {
  Operator: string;
  usage: string;
  function: string;
  example: string;
}

export interface slide7 {
  Operators: string;
  google: string;
  uspto: string;
  espacenet: string;
  wipo: string;
}


const ELEMENT_DATA: slide3[] = [
  { beginner: 'More time required to understand and search the unfamiliar search tools', professional: 'Expertise in using patent search tools & quickly find closer references' },
  { beginner: 'Possibilities of missing highly closer references for your invention', professional: 'Do thorough Search as like Patent office and leaves less room for missing of references closer to your invention' },
  { beginner: 'Need to rely only open source search tools', professional: 'Ability to access commercial search tools that have exhaustive coverage of Patents and publications' },

];

const ELEMENT_DATA1: slide5[] = [
  { Operator: 'AND', usage: 'Word1 and word2', function: 'Documents should include both Word1 and word2', example: 'Mobile AND cover' },
  { Operator: 'OR', usage: 'Word1 or word2', function: 'Documents can include either Word1 or word2', example: '(Mobile OR phone OR cell)(cover OR case)(LED OR light or lamp)' },
  { Operator: 'NOT', usage: '(Word1 and word2) not word2', function: 'Documents should not include word3', example: '(LED AND light emitting)NOT fluorescent' },
  { Operator: '“” (Quotation marks)', usage: '“word1 word2”', function: 'For prioritizing and find those words as such in documents', example: '“Smart phone” OR “Cell phone” OR “LED cover”' },
];



const ELEMENT_DATA2: slide7[] = [
  { Operators: 'BOOLEAN', google: 'AND (+) – Searches both words', uspto: 'AND - Searches both words', espacenet: 'AND – Searches both words', wipo: 'AND - Searches both words' },
  { Operators: 'BOOLEAN', google: 'OR (|) – searches at least one of the words', uspto: 'OR – searches at least one of the words or both words', espacenet: 'OR – searches at least one of the words', wipo: 'OR - searches at least one of the words or both words' },
  { Operators: 'BOOLEAN', google: 'NOT (-) – removes a word or phrase', uspto: 'ANDNOT – searches one word alone', espacenet: 'NOT – removes a word or phrase', wipo: 'ANDNOT - searches one word alone ' },
  { Operators: 'Proximity operators ', google: 'NEAR or ADJ – nearby words', uspto: 'NA', espacenet: 'prox/distance<n – searches for words within/ less than n number of words', wipo: 'NEAR – by default within 5 words' },
  { Operators: 'Proximity operators ', google: 'WITH – Searches within 20', uspto: 'NA', espacenet: 'prox/unit=sentence – searches for words within sentence', wipo: '“lighting sensor” ~10 – within 10 words' },
  { Operators: 'Proximity operators ', google: 'SAME – Searches within next 200 words', uspto: 'NA', espacenet: 'prox/unit=paragraph – searches for words within a paragraph', wipo: 'NA' },
  { Operators: 'Proximity operators ', google: 'NA', uspto: 'NA', espacenet: 'NA', wipo: 'light^10 sensor – priority for light is high when compared to sensor' },
  { Operators: 'Truncation operators', google: '* - zero or one character', uspto: 'NA', espacenet: '? - zero or one character', wipo: '? - zero or one character' },
  { Operators: 'Truncation operators', google: '# - exactly one character', uspto: 'NA', espacenet: '#  - exactly one character', wipo: 'NA' },
  { Operators: 'Truncation operators', google: '* - unlimited characters', uspto: '$ - unlimited characters', espacenet: '* - unlimited characters', wipo: '* - unlimited characters' },
  { Operators: 'Truncation operators', google: '$ - zero or more characters', uspto: 'NA', espacenet: 'NA', wipo: 'NA' },
  { Operators: 'Truncation operators', google: '$x – zero to x characters', uspto: 'NA', espacenet: 'NA', wipo: 'NA' },
];

